<template>
  <div class="car-maintenance car-reduced-width" :key="optionalMaintenancePositions.length">
    <spinner v-if="maintenance.loading" class="car-spinner car-content-spinner" />
    <div class="car-error-message" v-if="maintenance.requestError">
      {{$t('maintenanceSelection.errors.requestError')}}
    </div>

    <div class="car-maintenance-positions" v-if="!maintenance.loading && !maintenance.requestError">
      <div class="car-maintenance-position">
        <label>{{$t('maintenanceSelection.mandatorySubtitle')}}</label>
        <div class="car-maintenance-position-content">
          <div class="car-items">
            <div class="car-item" v-for="(position, index) in requiredMaintenancePositions" :key="index">
              <checkbox :label="position.description" :is-selected="true" :disabled="true"/>
            </div>
          </div>
        </div>
      </div>

      <div class="car-maintenance-position">
        <label>{{$t('maintenanceSelection.optionalSubtitle')}}</label>
        <div class="car-maintenance-position-content">
          <div class="car-items">
            <div class="car-item" v-for="(position, index) in optionalMaintenancePositions" :key="index" @click="selectPosition(position, index)">
              <checkbox :label="position.description" :is-selected="!!selectedPositions[index]"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="car-form-buttons car-buttons" v-if="!maintenance.loading">
      <primary-btn data-js="cardess-button--confirm" class="car-btn car-btn-primary" @click="close(false)" v-if="!maintenance.requestError">
        {{$t('maintenanceSelection.confirm')}}
      </primary-btn>
      <button data-js="cardess-button--cancel" class="car-btn car-btn-default" @click="close(true)">
        {{$t('maintenanceSelection.cancel')}}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'vue-simple-spinner';
import Checkbox from '@/components/Checkbox';
import PrimaryBtn from '@/components/PrimaryBtn';

export default {
  name: 'MaintenanceSelection',
  props: ['maintenance'],
  data: function () {
    return {
      selectedPositions: {}
    }
  },
  methods: {
    selectPosition: function(position, index) {
      this.selectedPositions[index] ? delete this.selectedPositions[index] : this.selectedPositions[index] = position;
      this.$forceUpdate();
    },
    close: function(cancelBool) {
      if (!cancelBool) {
        // save selected maintenance positions with corresponding service id to the vuex store
        this.$store.dispatch('vehicleServices/setMaintenancePositionsToService', {
          serviceId: this.maintenance.service.id,
          maintenancePositions: [...this.requiredMaintenancePositions, ...Object.values(this.selectedPositions)]
        });
        this.$store.dispatch('vehicleServices/addService', this.maintenance.service);
      }
      this.selectedPositions = {};
      this.$emit('close', cancelBool);
    }
  },
  computed: {
    ...mapGetters('vehicleServices', {
      optionalMaintenancePositions: 'optionalMaintenancePositions',
      requiredMaintenancePositions: 'requiredMaintenancePositions'
    })
  },
  components: {
    PrimaryBtn,
    Spinner,
    Checkbox
  }
}
</script>
